<script setup lang="ts">
const config = useRuntimeConfig()
</script>
<template>
  <!-- Pre-Footer -->
  <div class="container">
    <div class="row mt-4">
      <div class="col text-center mb-4">
        <h4 class="fs-2">Alasan harus memesan di {{ config.public.systemName }}?</h4>
      </div>
      <div class="row text-center">
        <div class="col-md-3 mt-4">
          <img  src="/images/everytime.png" width="212" alt="" /><br />
          <span class="fw-bold text-center fs-5"
            >Praktis, Dimanapun, Kapanpun</span
          >
          <p>
            Bebas bertransaksi disituasi apapun, dimanapun, dan kapanpun,
            <br />mulai dari web desktop, web mobile, ataupun aplikasi mobile.
          </p>
        </div>
        <div class="col-md-3">
          <img  src="/images/trusted.png" width="200" alt="" /><br />
          <span class="fw-bold text-center fs-5">Layanan<br />Terpercaya</span>
          <p>
            Anda akan mendapatkan layanan terbaik sesuai dengan apa yang Anda
            bayar!
          </p>
        </div>
        <div class="col-md-3 mt-4">
          <img  src="/images/secured.png" width="200" alt="" /><br />
          <span class="fw-bold text-center fs-5">Keamanan<br />Terjamin</span>
          <p>
            Teknologi SSL dari RapidSSL dengan Sertifikat yang terotentikasi
            menjamin privasi dan keamanan transaksi online Anda.
            <br />Konfirmasi instan dan e-tiket dikirim langsung ke email Anda.
          </p>
        </div>
        <div class="col-md-3">
          <img  src="/images/payment.png" width="185" alt="" /><br />
          <span class="fw-bold text-center fs-5"
            >Metode Pembayaran Yang Mudah</span
          >
          <p>
            Pembayaran yang mudah dan fleksibel dengan berbagai pilihan metode
            pembayaran, mulai dari ATM, Transfer Bank, Kartu Kredit, Bayar Tunai
            di Konter, hingga Internet Banking.
          </p>
        </div>
      </div>
    </div>
  </div>
  <!-- End Pre-Footer-->
</template>